import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { UntilDestroy } from "@ngneat/until-destroy";
import { NzUploadFile } from "ng-zorro-antd/upload";
import { BehaviorSubject } from "rxjs";

@Component({
  selector: 'om-file-upload',
  templateUrl: 'om-file-upload.component.html'
})
@UntilDestroy()
export class OmFileUploadComponent implements OnInit {
  @Input() control: FormControl;
  @Input() label: string;
  @Input() disabled: boolean = false;
  @Input() showError: boolean = true;
  @Input() limit: number = 1;
  @Input() useEvent: boolean = false;
  @Output() updateChange: EventEmitter<NzUploadFile[]> = new EventEmitter();
  @Output() fileRemove: EventEmitter<NzUploadFile> = new EventEmitter();

  fileList: NzUploadFile[] = [];

  isRequired$ = new BehaviorSubject<boolean>(false);

  constructor() {}

  ngOnInit(): void {
    this.isRequired$.next(!!this.control && this.control.hasValidator(Validators.required));
  }
  
  beforeUpload = (file: NzUploadFile): boolean => {
    if (this.fileList.length >= this.limit) {
      console.error('[OmFileUploadComponent]:: max file limit');
      return;
    }
    this.fileList = this.fileList.concat(file);
    if (!this.useEvent) {
      this.control.setValue(this.fileList);   
    } else {
      this.updateChange.emit(this.fileList);
    }
    return false;
  };

  removeFile = (file: NzUploadFile): boolean => {
    if (!this.useEvent) {
      this.control.enable();
    }
    this.fileRemove.emit(file);
    return true;
  }
}
